import API from '@/config/api';

const roles = [
    "ADMIN",
    "GENERAL_MANAGER",
    "SALES_MANAGER",
    "AREA_SALES_MANAGER",
    "TEAM_LEADER",
    "SALES_EXECUTIVE",
    "SR_SALES_EXECUTIVE",
    "MANAGEMENT_TRAINEE",
    "ACCOUNTS_EXECUTIVE",
    "ACCOUNTS_MANAGER",
    "SERVICE_EXECUTIVE",
    "SERVICE_MANAGER",
    "RESERVATION_EXECUTIVE",
    "RESERVATIONS_MANAGER",
    "CUSTOMER_CARE_EXECUTIVE",
    "CUSTOMER_CARE_MANAGER",
    "FRONT_OFFICE_EXECUTIVE",
    "DIGITAL_MARKETING_MANAGER",
    "WEB_DEVELOPER",
    "WEB_DESIGNER"
];

const leadSource = [
    "Advertisement",
    "Cold Call",
    "Employee Referral",
    "Client Referral",
    "External Referral",
    "Website",
    "Public Relation",
    "Email Campaign",
    "SMS Campaign",
    "Trade Show",
    "Old Customer",
    "New Customer",
    "Walk In",
    "SEO",
    "Excel",
    "Just Dial",
    "Phone Call",
    "Airbnb",
    "Live Chat",
    "Tripoto",
    "Hello Travel",
    "TripShelf",
    "Newspaper",
    "Sulekha",
    "Travel Triangle",
    "Trip Crafters",
    "Flyer",
    "Travelsetu",
    "Facebook",
    "Google Ads",
    "Instagram",
    "10Times",
    "Rotary",
    "BNI",
    "YES",
    "Mail",
    "Agent",
    "Google",
    "Whatsapp",
    "Webmail",
    "Direct Sale",
    "Incoming Call",
    "Chat",
    "Brouchers",
    "Mehul Business Solution",
    "Other",
    "None",
]

const salutations = [
    "Mr",
    "Mrs",
    "Ms",
    "Dr"
]

const customerType = [
    "B2C",
    "B2B",
    "Corporate",
    "VIP"
]

const leadPriority = [
    "Cold",
    "Warm",
    "Hot"
]

const leadStatus = [
    "Unqualified",
    "New",
    "Working",
    "Proposal Sent",
    "Negotiating",
    "Booked",
    "Lost",
    "Postponed",
]
const workingSubStatus = [
    "New",
    "Ops",
    "Sales"
]
const bookingSubStatus = [
    "Booked",
    "Partial Payment",
    "Supplier Conf",
    "Payment Completed",
    "Completed",

]

const tripType = [
    "Adventure",
    "Family",
    "Honeymoon",
    "Official",
    "Corporate",
    "Educational",
    "Group",
    "Individual",
    "Other",
    "Religious",
    "Couple",
    "Student Group"
]

const mealType = [
    "AP (Full Board )",
    "MAP (Half Board)",
    "CP (Only Breakfast)",
    "EP (No Meals )",
    "Any (Any type of meal)",
    "AI (All Inclusive)"
]

const otherData = [
    "Free Wi-Fi",
    "Airport transfers - Private",
    "Airport transfers - SIC",
    "Travel Insurance",
    "Visa",
    "Inter Hotel Transfer- Private",
    "Sightseeing Transfers - Private",
    "Sightseeing Transfers - SIC",
    "Airport transfers - Speed Boat/Sea Plane",
    "Inter Hotel Transfer- SIC",
    "Candlelight Dinner",
    "Bed Decorations",
    "Honeymoon Cake",
    "Private Ferry"
]

const hotelType = [
    "Standard",
    "Deluxe",
    "Luxury",
    "Budget"
]

const roomTypes = [
    "Single",
    "Superior",
    "Deluxe",
    "Budget",
    "Villa",
    "Quadraple",
    "Dormitory",
    "Any",
    "Standard",
    "Double",
    "Luxury",
    "Premium",
    "Triple",
    "Suite",
    "Apartment",
]

const amenities = [
    "Wifi",
    "Parking",
    "Laundry Service",
    "Doctor",
    "Foreign Exchange"
]
const rating = [
    1, 2, 3, 4, 5
]
const enquiryType = [
    "Flight Booking",
    "Hotel Booking",
    "Visa",
    "Travel Insurance",
    "Forex",
    "Sightseeing",
    "Transport",
    "Other",
    "Package",
    "Customize Package",
]

const visaCategory = [
    "Business",
    "Tourist",
    "Student",
    "Work",
    "Transit",
    "Visitor"
]

const visitType = [
    "Single",
    "Double",
    "Multiple"
]
const transports = [
    "SIC",
    "PVT",
    "Other"
]
const preferences = [
    "Private",
    "SIC",
    "Self Drive",
    "Chauffer"
]

const flightPreferences = [
    "Direct",
    "One Stop",
    "Cheapest",
]

const services = [
    "Flight",
    "Hotel",
    "Sightseeing",
    "Visa",
    "Transport"
]

const flightFlexibility = [
    "+/- 0 Day",
    "+/- 1 Day",
    "+/- 2 Day",
    "+/- 3 Day",
    "+/- 4 Day",
    "+/- 5 Day",
    "+/- 6 Day",
    "+/- 7 Day",
]

const flightClass = [
    "Economy",
    "Premium Economy",
    "Business",
    "First Class"
]

const bookedSubStatus = [
    "Booked",
    "Partial Payment",
    "Supplier Conf",
    "Payment Completed",
    "Completed",
]

const getCities = async (data = false) => {
    try {
        let queryString = "";
        if (data?.name) queryString = `name=${data.name}&`
        if (data?.id) queryString = `id=${data.id}&`
        if (data?.countryName) queryString = `${queryString}countryName=${data.countryName}&`
        if (data?.countryId) queryString = `${queryString}countryId=${data.countryId}&`
        if (data?.stateName) queryString = `${queryString}stateName=${data.stateName}&`
        if (data?.stateId) queryString = `${queryString}countryId=${data.stateId}&`
        const response = await API.generalRequest.get(`/cities?${queryString}`);
        const cities = response.data.data;
        return cities;
    } catch (error) {
        console.log(error);
    }
}
const getStates = async (data = false) => {

    try {
        let queryString = "";
        if (data?.name) queryString = `name=${data.name}&`
        if (data?.id) queryString = `id=${data.id}&`
        if (data?.countryName) queryString = `${queryString}countryName=${data.countryName}&`
        if (data?.countryId) queryString = `${queryString}countryId=${data.countryId}&`

        const response = await API.generalRequest.get(`/states?${queryString}`);
        const states = response.data.data;
        return states;

    } catch (error) {
        console.log(error);
    }
}
const getCountries = async (data = false) => {
    try {
        let queryString = "";
        if (data?.name) queryString = `name=${data.city}&`
        if (data?.id) queryString = `id=${data.id}&`
        const response = await API.generalRequest.get(`/countries?${queryString}`);
        const countries = response.data.data;
        return countries;
    } catch (error) {
        console.log(error);
    }
}

export default {
    tripType,
    leadStatus,
    workingSubStatus,
    bookingSubStatus,
    leadPriority,
    leadSource,
    roles,
    salutations,
    customerType,
    mealType,
    otherData,
    hotelType,
    amenities,
    rating,
    enquiryType,
    roomTypes,
    visaCategory,
    visitType,
    transports,
    preferences,
    flightPreferences,
    flightFlexibility,
    flightClass,
    services,
    getCities,
    getStates,
    getCountries,
}